import { motion } from "framer-motion";

const easeOutCubic = [0.33, 1, 0.68, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easeOutCubic }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const MaskLine = ({ children, delay = 0, className = "" }) => {
  return (
    <span className="block overflow-hidden">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.1, delay, ease: easeOutCubic }}
      >
        {children}
      </motion.span>
    </span>
  );
};
